import { render, staticRenderFns } from "./CartQuantity.vue?vue&type=template&id=039c8bea&lang=true&"
import script from "./CartQuantity.vue?vue&type=script&lang=js&"
export * from "./CartQuantity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports